// components/Loader.jsx
import Style from '../style/loadingSpinner.module.scss'

function Loader({ size = "medium", color = "#553D81" }) {
  return (
    <div className={`${Style.loader_overlay}`}>
      <div className={`${Style.loader} ${Style[size]}`}>
        <div style={{ borderLeftColor: color }}></div>
      </div>
    </div>
  );
}

export default Loader;